module.exports = __webpack_public_path__ + "static/media/pg-example.4dbb2305.jpg";